import React, { useCallback } from "react";

// Compoenents
import RoomGuestControl from "./RoomGuestControl";
import RoomGuestInput from "./RoomGuestInput";
import CommonDrawer from "components/Design/Drawer/Drawer";
import DrawerHead from "components/Design/Drawer/DrawerHead";
import PrimaryButtonFullWidth from "components/Design/Button/PrimaryButtonFullWidth";

// hooks
import useDrawer from "hooks/useDrawer";

//translation
import { useTranslation } from "gatsby-plugin-react-i18next";

const RoomGuestSelectDrawer = ({
  rooms,
  adults,
  children,
  infants,
  onSave,
  fieldError,
  suffixIcon,
  location,
}) => {
  const { open, close, reset, update, state, isOpen } = useDrawer({
    isOpen: false,
    rooms,
    adults,
    children,
    infants,
  });

  const saveHandler = useCallback(() => {
    onSave({
      rooms: state.rooms,
      adults: state.adults,
      children: state.children,
      infants: state.infants,
    });
    close();
  }, [state]);

  const { t } = useTranslation("homepage");
  return (
    <div className="w-full h-full relative">
      <RoomGuestInput
        error={fieldError}
        rooms={state.rooms}
        children={state.children}
        adults={state.adults}
        infants={state.infants}
        onClick={open}
        suffixIcon={suffixIcon}
      />

      <CommonDrawer
        className="room-guest-drawer"
        destroyOnClose
        visible={isOpen}
        onClose={reset}
        placement="bottom"
        height="100%">
        <>
          <DrawerHead title={t("Room & Guest")} onClose={reset} />
          <span className="font-mulish block text-14-24 text-center mt-34">
            {t("How Many Room and Guest?")}
          </span>
          <RoomGuestControl
            onChange={update}
            rooms={state.rooms}
            adults={state.adults}
            children={state.children}
            infants={state.infants}
            location={location}
          />
          <div className="absolute bottom-0 w-full p-20">
            <PrimaryButtonFullWidth label={t("Save")} onClick={saveHandler} />
          </div>
        </>
      </CommonDrawer>
    </div>
  );
};

export default RoomGuestSelectDrawer;
